import React from 'react'
import './nav.css'

/* const [activeNav, setActiveNav] = useState('#')
will circle the home icon */
/*===================== version 1 =====================*/
// const Nav = () => {
//     const [activeNav, setActiveNav] = useState('#')

//     return (
//         <nav>
//             <a href="#" onClick={() => setActiveNav('#')}className={activeNav === '#' ? 'active' : ''}><AiOutlineHome/></a>
//             <a href="#about" onClick={() => setActiveNav('#about')} className={activeNav === '#about' ? 'active' : ''}><AiOutlineUser/></a>
//             <a href="#experience" onClick={() => setActiveNav('#experience')} className={activeNav === '#experience' ? 'active' : ''}><AiOutlineFieldTime/></a>
//             <a href="#contact"onClick={() => setActiveNav('#contact')} className={activeNav === '#contact' ? 'active' : ''}><AiOutlineMessage/></a>
//         </nav>
//     )
// }

// export default Nav

/*===================== version 2 nav raw =====================*/
const Nav = () => {
    // const [activeNav, setActiveNav] = useState('#')
    return null;
}
export default Nav
